import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Index } from './pages/index';
import { LoginComponent } from './pages/login/login';
import { ResetPasswordComponent } from './pages/reset-password/reset-password';
import { DashboardLayout } from './pages/dashboard/dashboard-layout/dashboard-layout';
import { Overview } from './pages/dashboard/overview/overview';
import { AuthGuard } from './helpers/auth-guard';
import { Subjects } from './pages/dashboard/subjects/subjects';
import { SubjectOfferings } from './pages/dashboard/subject-offerings/subject-offerings';
import { AcademicYears } from './pages/dashboard/academic-years/academic-years';
import { ContentPublisher } from './pages/dashboard/content-publisher/content-publisher';
import { ActivationCodeManager } from './pages/dashboard/activation-code-manager/activation-code-manager';
import { NotFoundComponent } from './pages/not-found/not-found';
import { ForbiddenComponent } from './pages/forbidden/forbidden';

const routes: Routes = [
  {
    path: '',
    component: Index,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'dashboard',
    component: DashboardLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: Overview,
      },
      {
        path: 'subjects',
        component: Subjects,
      },
      {
        path: 'subject-offerings',
        component: SubjectOfferings,
      },
      {
        path: 'academic-years',
        component: AcademicYears,
      },
      {
        path: 'content',
        component: ContentPublisher,
      },
      {
        path: 'activation-codes',
        component: ActivationCodeManager,
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
